import { Container, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDocument } from "../hooks/useDocument";
import { useParams } from "react-router-dom";
import Page from "../components/Page";

export default function SalesReport() {
  const [name, setName] = useState("");
  const [craneModel, setCraneModel] = useState("");
  const [craneNo, setCraneNo] = useState("");
  const [jobDesc, setJobDesc] = useState("");
  const [quote, setQuote] = useState("");
  const [price, setPrice] = useState("");
  const [currency, setCurrency] = useState("");
  const [date, setDate] = useState("");
  const [valueOfQuote, setValueOfQuote] = useState("");
  const [akolisaQuote, setAkolisaQuote] = useState("");
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [supplier, SetSupplier] = useState("");
  const [status, setStatus] = useState("");
  const [origin, setOrigin] = useState("");
  const [remark, setRemark] = useState("");

  const { document } = useDocument("Sale");
  const { id } = useParams();
  useEffect(() => {
    const detail = async () => {
      try {
        const docSnap = await document(id);
        // console.log(docSnap.data())
        setName(docSnap.data().name);
        setCraneModel(docSnap.data().craneModel);
        setCraneNo(docSnap.data().craneNo);
        setJobDesc(docSnap.data().jobDesc);
        setCurrency(docSnap.data().currency);
        setQuote(docSnap.data().quote);
        setPrice(docSnap.data().price);
        setDate(docSnap.data().date);
        setAkolisaQuote(docSnap.data().akolisaQuote);
        setYear(docSnap.data().year);
        SetSupplier(docSnap.data().supplier);
        setMonth(docSnap.data().month);
        setStatus(docSnap.data().status);
        setOrigin(docSnap.data().origin);
        setRemark(docSnap.data().remark);
        setValueOfQuote(docSnap.data().valueOfQuote);
      } catch (error) {
        // console.log(error)
      }
    };
    if ((id !== undefined || id !== "") && id !== ":id") {
      detail();
    }

    // eslint-disable-next-line
  }, [id]);

  return (
    <Page title="Sales Report">
      <Container maxWidth="xl">
        <Paper elevation={6} sx={{ p: 4 }}>
          <Grid component="div" container sx={{ border: "1px solid" }}>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body" sx={{ margin: 0.5 }}>
                <b>Customer Name: </b>{" "}
              </Typography>
              <Typography variant="body" sx={{ margin: 0.5 }}>
                {" "}
                {name}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body" sx={{ margin: 0.5 }}>
                <b>Crane Model: </b>{" "}
              </Typography>
              <Typography variant="body" sx={{ margin: 0.5 }}>
                {" "}
                {craneModel}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Crane SN: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {craneNo}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Job Description: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {jobDesc}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Quote / Invoice: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {quote}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Price / Value of supplt: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {price}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Currency: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {currency}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Date Of Quote: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {date}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Akolisa Quote No: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {akolisaQuote}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Value of Akolisa Quote: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {valueOfQuote}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Year Of Quote / Invoice: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {year}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Month Of Quote / Invoice: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {month}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Supplier: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {supplier}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Status: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {status}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Origin Of Leads: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {origin}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", border: "1px solid", padding: 1 }}
              component="div"
            >
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                <b>Remarks: </b>{" "}
              </Typography>
              <Typography variant="body1" sx={{ margin: 0.5 }}>
                {" "}
                {remark}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Page>
  );
}
